import api from './Api'; // Adjust the path based on your project structure

const BASE_URL = 'affSystems/';

export default {
  getAll: () => {
    return api.get(BASE_URL);
  }
};
